import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PompesChaleur from "../pages/pompes-chaleur/page";
import Electricite from "../pages/electricite/page";
import Sanitaire from "../pages/sanitaire/page";
import Ventilation from "../pages/ventilation/page";
import Domotique from "../pages/domotique/page";
import Maintenance from "../pages/maintenance/page";
import MentionsLegales from "../pages/mentions-legales/page";
import CGV from "../pages/cgv/page";
import Blog from "../pages/blog/page";
import Temoignages from "../pages/temoignages/page";
import FAQ from "../pages/faq/page";
import EntrepriseGenerale from "../pages/entreprise-generale/page";
import NettoyageConciergerie from "../pages/nettoyage-conciergerie/page";
import Renovation from "../pages/renovation/page";
import AideDomicile from "../pages/aide-domicile/page";
import ZonesIntervention from "../pages/zones-intervention/page";
import Recrutement from "../pages/recrutement/page";
import Presentation from "../pages/presentation/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/pompes-chaleur",
    element: <PompesChaleur />,
  },
  {
    path: "/electricite",
    element: <Electricite />,
  },
  {
    path: "/sanitaire",
    element: <Sanitaire />,
  },
  {
    path: "/ventilation",
    element: <Ventilation />,
  },
  {
    path: "/domotique",
    element: <Domotique />,
  },
  {
    path: "/maintenance",
    element: <Maintenance />,
  },
  {
    path: "/entreprise-generale",
    element: <EntrepriseGenerale />,
  },
  {
    path: "/nettoyage-conciergerie",
    element: <NettoyageConciergerie />,
  },
  {
    path: "/renovation",
    element: <Renovation />,
  },
  {
    path: "/aide-domicile",
    element: <AideDomicile />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/temoignages",
    element: <Temoignages />,
  },
  {
    path: "/faq",
    element: <FAQ />,
  },
  {
    path: "/mentions-legales",
    element: <MentionsLegales />,
  },
  {
    path: "/cgv",
    element: <CGV />,
  },
  {
    path: "/zones-intervention",
    element: <ZonesIntervention />,
  },
  {
    path: "/recrutement",
    element: <Recrutement />,
  },
  {
    path: "/presentation",
    element: <Presentation />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
